import {
    HiOutlineCog,
    HiOutlineHome,
    HiOutlineQuestionMarkCircle,
    HiOutlineReceiptTax,
    HiOutlineServer,
    HiOutlineViewList,
    HiUserGroup,
    HiOutlineMail,
    HiOutlineDocumentText,
    HiOutlinePencil,
    HiOutlineStatusOnline,
    HiOutlineExclamationCircle,
    HiOutlineClipboardList,
    HiOutlineDocumentReport
} from 'react-icons/hi'

export const Dashboard_Sidebar_Link = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        path: '/',
        icon: <HiOutlineHome />
    },

    //     {
    //     key: 'transactions',
    //     label: 'Dashboard',
    //     path: '/transactions',
    //     icon:<HiOutlineHome  />
    // },
        {
        key: 'purchase-orders',
        label: 'Create Lead',
        path: '/purchase-orders',
        icon: <HiOutlineReceiptTax />
    },
    // {
    //     key: 'inventory',
    //     label: 'All-Leads',
    //     path: '/All-items',
    //     icon: <HiOutlineCollection/>
    // },
    
    // {
    //     key: 'withoutpogenerates',
    //     label: 'Create Delivery Note',
    //     path: '/withoutpogenerates',
    //     icon: <HiPlusCircle />
    // },



    {
        key: 'customers',
        label: 'Contacts Details',
        path: '/customers',
        icon: <HiUserGroup />
    },

    //     {
    //     key: 'invoices',
    //     label: 'Master Data',
    //     path: '/invoices',
    //     icon: <HiOutlineViewList />
    // },
         {
        key: 'vendors',
        label: 'Follow up',
        path: '/vendors',
        icon: <HiOutlineServer />
    },
    {
        key: 'SalesPerson',
        label: 'Master Data',
        path: '/sales',
        icon:<HiOutlineViewList />
    },
    {
        key: 'campaign-status',
        label: 'Live Campaign',
        path: '/campaign-status',
        icon: <HiOutlineStatusOnline />,
        exact: false
    },
    {
        key: 'mail',
        label: 'Mail config',
        path: '/mail',
        icon: <HiOutlineMail />
    },
    {
        key: 'mail-service-types',
        label: 'Service types (e.g. RPA)',
        path: '/mail/service-types',
        icon: <HiOutlineServer />
    },
    {
        key: 'mail-services',
        label: 'Mail services',
        path: '/mail/services',
        icon: <HiOutlineCog />
    },
    {
        key: 'mail-templates',
        label: 'Mail templates',
        path: '/mail/templates',
        icon: <HiOutlineDocumentText />
    },
    {
        key: 'failed-emails',
        label: 'Failed Emails',
        path: '/mail/failed',
        icon: <HiOutlineExclamationCircle />
    },
    {
        key: 'signatures',
        label: 'Signatures',
        path: '/signatures',
        icon: <HiOutlinePencil />
    },
            {
        key: 'Propsoal',
        label: 'Propsoal',
        path: '/propsoal',
        icon:<HiOutlineClipboardList  />
    },
            {
        key: 'RateCard',
        label: 'RateCard',
        path: '/RateCard',
        icon:<HiOutlineDocumentReport  />
    },
                {
        key: 'PhotoMaker',
        label: 'PhotoMaker',
        path: '/PhotoMaker',
        icon:<HiOutlineDocumentReport  />
    },
]
export const Dashboard_sidebar_bottom_Link = [
    // {
    //     key: 'setting',
    //     label: 'Settings',
    //     path: '#',
    //     icon: <HiOutlineCog />
    // },
    {
        key: 'support',
        label: 'Help & Support',
        path: '/help',
        icon: <HiOutlineQuestionMarkCircle />
    },
]
    
